// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qysFii7kArcvNt {
  position: absolute;
  z-index: 10;
  top: -290px;
  right: -14px;
}
.Ry4yznS2mu2cit {
  position: relative;
}
`, ""]);
// Exports
export var closeButton = `qysFii7kArcvNt`;
export var contentWrapper = `Ry4yznS2mu2cit`;
export default ___CSS_LOADER_EXPORT___;
